export default __webpack_public_path__ + "static/media/19.914476f0.webp";